import {Component, Input, OnInit, Output, EventEmitter, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {noop} from 'rxjs';
import {TdoSearchEvent} from './models/TdoSearchEvent';

/*const noop = () => {
};*/

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TdoSearchComponent),
  multi: true
};

@Component({
  selector: 'app-tdo-search',
  templateUrl: './tdo-search.component.html',
  styleUrls: ['./tdo-search.component.css'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class TdoSearchComponent implements OnInit, ControlValueAccessor {
  @Input() isClearable: boolean = true;
  @Input() placeholder = 'Search';
  @Input() class;
  @Input() id;
  @Input() style;
  @Input() disabled: boolean = false;
  @Input() floatLabel: string = 'auto';
  @Input() executionDelay: number = 0;
  @Input() initialSearchValue: string = '';

  @Output() searchCleared = new EventEmitter();
  @Output() searchChange = new EventEmitter();

  private innerValue: any = '';
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor() {

  }

  ngOnInit(): void {
    if (this.initialSearchValue) {
      this.value = this.initialSearchValue;
    }
  }

  onSearchInput(event) {
    //
  }

  onClearSearch() {
    this.value = '';
    this.searchCleared.emit();
    this.searchChange.emit(new TdoSearchEvent(this.value));
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
      if (this.executionDelay === 0) {
        this.searchChange.emit(new TdoSearchEvent(this.value));
      }
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onInputFinished(event: string) {
    this.searchChange.emit(new TdoSearchEvent(this.value));
  }
}
